import { Content } from '../../types';

export const kohPhanganContent: Content = {
  title: 'קו פנגן Koh Phangan',
  imageUrl: '/images/thailand/koh-phangan/koh-phangan-wide.jpg',
  introduction:
    'אי במפרץ תאילנד, בדרום מזרח המדינה, כ-15 ק"מ מקו סאמוי ומשתייך למחוז סוראט תאני. האי ידוע בזכות שילוב מושלם בין חופים קסומים ומבודדים לבין חיי לילה סוערים, עם מסיבות הפולמון, ההאלפמון והג\'אנגל, מסיבות המתקיימות בו מדי חודש.',
  sections: [
    {
      title: 'החופים היפים של קו פנגן',
      type: 'sub-headers',
      description:
        'קו פנגן משופע בחופים אקזוטיים, שכל אחד מהם מציע חוויות שונות:',
      content: [
        {
          subtitle: 'חוף האדרין (Haad Rin)',
          text: 'החוף המפורסם ביותר באי, בו מתקיימת מסיבת ה-Full Moon Party. החוף מחולק לשני חלקים:<br /><br />האדרין נוק (Haad Rin Nok) – החוף המרכזי של המסיבות, עם חול לבן, מים צלולים ומגוון רחב של מסעדות, ברים ומועדונים.<br /><br />האדרין נאי (Haad Rin Nai) – החוף המערבי, רגוע יותר, ממנו ניתן לצפות בשקיעות מרהיבות.',
        },
        {
          subtitle: 'חוף טונג נאי פאן (Thong Nai Pan)',
          text: 'בצפון-מזרח האי, מורכב משני חופים:<br /><br />טונג נאי פאן נוי (Thong Nai Pan Noi) – חוף יוקרתי עם מלונות בוטיק, מסעדות איכותיות ושקט קסום.<br /><br />טונג נאי פאן יאי (Thong Nai Pan Yai) – חוף ארוך עם אווירה רגועה, מושלם למשפחות וזוגות.',
        },
        {
          subtitle: 'Bottle Beach (Haad Khuat)',
          text: 'חוף נסתר ומבודד בצפון האי, נגיש בעיקר בסירה או דרך מסלול הליכה אתגרי. החוף שקט ומרהיב ביופיו, עם מים צלולים ושוניות עשירות בדגים.',
        },
        {
          subtitle: 'חוף יאו (Haad Yuan)',
          text: "ממוקם קרוב לחוף האדרין אך מציע אווירה שקטה ורגועה יותר. ניתן להגיע אליו בסירה או בהליכה דרך הג'ונגל.",
        },
        {
          subtitle: 'Secret Beach',
          text: 'חוף קטן ונסתר עם מים צלולים ואווירה של רוגע מוחלט, מושלם לשחייה ושנורקלינג.',
        },
        {
          subtitle: "חוף צ'או פאאו (Haad Chao Phao)",
          text: 'ממוקם בצד המערבי של האי, מציע שקיעות מהפנטות ואווירה רגועה עם ברים קטנים על החוף.',
        },
        {
          subtitle: 'חוף מאי האד (Mae Haad Beach)',
          text: 'חוף מיוחד המחובר לאי קו מה (Koh Ma) ברצועת חול צרה, מוקף בשוניות מדהימות המתאימות לשנורקלינג.',
        },
        {
          subtitle: 'חוף סריטאנו (Sri Thanu Beach) ו-Zen Beach',
          text: 'חוף פופולרי בקרב חובבי יוגה ומדיטציה, עם אווירה רוחנית ומרכזי ריפוי הוליסטיים. Zen Beach מפורסם בזכות השקיעות היפות שלו ומפגשים חברתיים בהם מתנגנת מוזיקה חיה באווירה רגועה.',
        },
        {
          subtitle: 'חוף מאליבו (Malibu Beach)',
          text: 'חוף יפהפה בצפון האי, עם חול לבן ומים בצבע טורקיז מרהיב. המקום אידיאלי לשחייה, מנוחה וצילום תמונות נוף קסומות.',
        },
      ],
    },
    {
      type: 'image',
      imageUrl: '/images/thailand/koh-phangan/koh-phangan-article-1.jpg',
      title: 'secret beach',
      content: '',
    },
    {
      title: 'מסיבות הפולמון וההאלפמון',
      type: 'sub-headers',
      description: 'קו פנגן ידוע במסיבות המיוחדות המתקיימות בו:',
      content: [
        {
          subtitle: 'מסיבת הפולמון (Full Moon Party)',
          text: 'אחת המסיבות המפורסמות ביותר בעולם, הנערכת אחת לחודש בחוף האדרין. אלפי אנשים מכל העולם מגיעים למסיבה כדי ליהנות ממוזיקה חיה, מופעי אש, צבעי גוף זוהרים וריקודים עד עלות השחר.',
        },
        {
          subtitle: 'מסיבת ההאלפמון (Half Moon Party)',
          text: "מתקיימת בג'ונגל הפנימי של האי פעמיים בחודש, ומציעה חוויה אינטימית יותר עם מוזיקת טראנס, מופעי תאורה ואווירה מיוחדת בין עצי הקוקוס.",
        },
      ],
    },
    {
      title: 'אטרקציות ופעילויות נוספות באי',
      type: 'sub-headers',
      description: 'מעבר לחופים ולמסיבות, קו פנגן מציע אטרקציות רבות נוספות:',
      content: [
        {
          subtitle: 'שקיעות וזריחות בלתי נשכחות',
          text: 'האי מציע נקודות תצפית מדהימות:<br /><br />Viewpoint Dome Sila – תצפית עוצרת נשימה על חוף האדרין.<br /><br />360 View Bar – מקום מושלם לצפות בשקיעה עם קוקטייל ביד.',
        },
        {
          subtitle: 'טרקים ומפלים',
          text: "קו פנגן מכוסה בג'ונגל פראי עם מסלולי טיול מרהיבים:<br /><br />פארק לאומי Than Sadet – מסלול יער עבות עם נהר, מפלים ובריכות טבעיות.<br /><br />מפלי Phaeng – תצפית עוצרת נשימה לאחר טיפוס קצר.",
        },
        {
          subtitle: 'שנורקלינג וצלילה',
          text: 'קו פנגן מוקף בשוניות צבעוניות:<br /><br />Koh Ma – אי קטן המחובר לקו פנגן, אתר מושלם לשנורקלינג.<br /><br />Sail Rock – אחד מאתרי הצלילה הטובים בתאילנד, במרחק הפלגה קצר.',
        },
        {
          subtitle: 'סדנאות יוגה ורוגע',
          text: 'קו פנגן הינו מוקד עולמי ליוגה ומדיטציה, עם מקומות כמו The Sanctuary ו-Orion Healing Center.',
        },
        {
          subtitle: 'שוק הלילה בטונגסאלה',
          text: 'בכל ערב מתקיים שוק אוכל עם דוכנים מגוונים ובשבת מתקיים שוק מיוחד – Saturday Walking Street Market.',
        },
        {
          subtitle: 'טיולי קאייקים וסירות',
          text: 'שיט לאורך החופים והאיים הסמוכים מאפשר לחקור פינות נסתרות ולהגיע לחופים בתוליים.',
        },
      ],
    },
    {
      title: 'איך להגיע ומה חשוב לדעת?',
      type: 'sub-headers',
      content: [
        {
          subtitle: 'דרכי הגעה',
          text: 'ניתן להגיע לקו פנגן במעבורות מקו סאמוי, סוראט תאני או קו טאו (מקו סאמוי וקו טאו אף בספיד בואט).',
        },
        {
          subtitle: 'מקומות לינה',
          text: 'האי מציע מגוון רחב של מקומות לינה – מהוסטלים זולים ועד ריזורטים מפוארים.',
        },
        {
          subtitle: 'למטיילים שומרי מסורת',
          text: 'למטיילים שומרי מסורת/ דתיים – קיים בית חב"ד בסריטאנו והבית הישראלי (מסעדה כשרה ובית כנסת) בהאדרין.',
        },
      ],
    },
    {
      title: 'סיכום',
      type: 'text',
      content:
        'בשורה התחתונה, קו פנגן הינו יעד אקזוטי עם חופים מהממים שלא תמצאו במקומות רבים ושמתאים לכל אחד – בין אם אתם מחפשים מסיבות, חופים מבודדים או חוויות טבע מרהיבות, האי הזה מציע הכול!',
    },
  ],
};
